import React from "react";
import Countdown from "react-countdown";

function Counter(props) {
  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (minutes > 0)
      return (
        <span>
          🕚{minutes}:{`${seconds}`.padStart(2, "0")}
        </span>
      );
    return <span>🕚{`${seconds}`.padStart(2, "0")}</span>;
  };
  const [time, setTime] = React.useState(props.initialCount);
  const onComplete = () => {
    setTime(time + 10000);
  };
  return (
    <Countdown
      renderer={renderer}
      key={Date.now() + time}
      date={Date.now() + time}
      onComplete={onComplete}
    ></Countdown>
  );
}

export { Counter };
